import React from 'react';
import Head from 'next/head';
import getSEOSchema from 'cards/components/CardListing/SEOContentBlock/helper';
import type { SEOData } from 'cards/seo/types';

type SEOSchemaProps = {
  seoData: SEOData;
};

export const SEOSchema = ({ seoData }: SEOSchemaProps): JSX.Element => {
  const { faqContent = [] } = seoData;
  return (
    <Head>
      {faqContent.length > 0 && (
        <script type="application/ld+json" key="cardPlpFaqSchema">
          {JSON.stringify(getSEOSchema(faqContent))}
        </script>
      )}
    </Head>
  );
};
